var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"GameDetail_box2_inner"},[_c('div',{staticClass:"indexTitle"},[_vm._v("游戏截图")]),_c('el-carousel',{attrs:{"interval":4000,"type":"card","height":"50em"}},_vm._l((_vm.msgs.imgsList),function(item){return _c('el-carousel-item',{key:item},[_c('img',{attrs:{"src":item,"alt":""}})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }